import styled from '@emotion/styled'
import { CircularProgress, Paper, Stack } from '@mui/material'
import React from 'react'
import { Link } from 'react-router-dom'

export const Widget = styled(Paper)`
  position: relative;
  padding: 8px;
  border-radius: 8px;
  min-height: 100%;
  min-height: 280px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
`

export const Main = styled.div`
  width: 100%;
`

export const AdditionalLegend = styled.span`
  font-size: 12px;
  margin-top: 5px;
  text-align: center;
  color: #464646;
`

export const WidgetContent = styled.div`
  margin-top: 10px;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const WidgetHeader = styled.h3`
  font-size: 16px;
  color: #464646;
  text-align: left;
  line-height: 22px;
  margin: 0;
  font-weight: normal;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (min-width: 768px) {
    font-size: 18px;
    line-height: 24px;
  }
`

export const WidgetSubHeader = styled.p`
  font-size: 12px;
  color: #464646;
  text-align: left;
  line-height: 18px;
  margin: 0;
`

const Progress = styled.div`
  position: relative;
  width: 92px;
  height: 92px;
`

const Value = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  font-size: 32px;
  color: #464646;
  display: flex;
  align-items: center;
  justify-content: center;
`

const LegendSymbol = styled.div`
  position: absolute;
  font-size: 20px;
  color: #464646;
  text-align: left;
  line-height: 18px;
  bottom: 0;
  right: 0;
  margin: 0 -6px 3px 0;
`

const ProgressBg = styled.div`
  position: absolute;
  top: 2px;
  left: 2px;
`

const ProgressFg = styled.div`
  position: absolute;
  top: -4px;
  left: 2px;
  transform: rotate(180deg);
`

const Legend = styled.p`
  margin: 14px 0 0;
  font-size: 12px;
  color: #464646;
  text-align: center;
  line-height: 18px;
`

export const Columns = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  @media (min-width: 768px) {
    flex-direction: row;
    gap: 24px;
    > * {
      flex: 1;
    }
  }
`

export const DateSelectorWrapper = styled.div`
  margin: 0 -8px;
`

export const ExportLink = styled(Link)`
  position: absolute;
  right: 16px;
  bottom: 16px;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  svg {
    width: 24px;
    height: 24px;
    fill: #78a22f;
  }
`

export function IncentiveSalesProgress({ value, legend }: { value: number | string; legend: React.ReactElement }) {
  const progressValue = typeof value === 'number' ? value : Number.parseFloat(value)

  return (
    <Stack direction='column' alignItems='center'>
      <Progress>
        <ProgressBg>
          <CircularProgress sx={{ color: '#D6D5D5' }} variant='determinate' size={88} value={100} thickness={2} />
        </ProgressBg>
        <ProgressFg>
          <CircularProgress
            sx={{
              color: '#464646',
            }}
            variant='determinate'
            thickness={4}
            size={89}
            value={!isNaN(progressValue) ? Math.min(Math.max(progressValue, 0), 100) : 0}
          />
        </ProgressFg>
        <Value>{value}</Value>
        <LegendSymbol>%</LegendSymbol>
      </Progress>
      {legend && <Legend>{legend}</Legend>}
    </Stack>
  )
}
